import { JSX } from 'react';

import { FlexAligner, Typography } from '@scaleaq/scaleui';
import { CornerDownLeft, Delete } from 'lucide-react';

import { KeyFace } from '@/components/hotKeyLineWithButtonAndDescription/shortCut.styles.ts';
import { Key } from '@/hooks/shortcutHooks/hotkeys/KeyStrokes.ts';
import { iconStyle } from '@/pages/layouts/getStartedModal/gettingStarted_KeyboardShortcuts/types.ts';
import { Icon } from '@/utils';

type KeyboardKeyWithOptionalIconProps = {
  keyboardKey: string;
};
export const KeyboardKeyWithOptionalIcon = ({ keyboardKey }: KeyboardKeyWithOptionalIconProps) => {
  let keyIcon: JSX.Element | undefined = undefined;
  switch (keyboardKey) {
    case Key.arrow.ArrowUp.keyboardKey:
      keyIcon = <Icon.ChevronUp style={iconStyle} />;
      break;
    case Key.arrow.ArrowDown.keyboardKey:
      keyIcon = <Icon.ChevronDown style={iconStyle} />;
      break;
    case Key.arrow.ArrowLeft.keyboardKey:
      keyIcon = <Icon.ChevronLeft style={iconStyle} />;
      break;
    case Key.arrow.ArrowRight.keyboardKey:
      keyIcon = <Icon.ChevronRight style={iconStyle} />;
      break;
    case Key.navigation.Backspace.keyboardKey:
      keyIcon = (
        <span style={{ width: '1.5rem' }}>
          <Delete size={20} />
        </span>
      );
      break;
    case Key.navigation.Enter.keyboardKey:
      keyIcon = (
        <span style={{ width: '1.5rem' }}>
          <CornerDownLeft size={20} />
        </span>
      );
      break;
  }
  return (
    <FlexAligner alignment='center'>
      <KeyFace>
        <Typography style={{ textWrapMode: 'nowrap' }}>{keyboardKey}</Typography>
        {keyIcon}
      </KeyFace>
    </FlexAligner>
  );
};
